import React from 'react';
import TweenOne from 'rc-tween-one';
import './../../assets/styles/OthersTitle.css'


const OthersTitle = props => {
    const isSurprise = (props.appState === 'firsttimevisit')
        ? true
        : false
    ;
    return (
        <TweenOne id="others_title" className={`others_title_container w-full max-w-md shadow-lg mx-auto text-white ${isSurprise ? 'hide' : ''}`} paused={isSurprise} animation={{ opacity: 1 }}>
            <p>Biblioteca</p>
        </TweenOne>
    );
}

export default OthersTitle;